<template>
        <nav  :class="navSection.styleClassesSection"  :key="_uid"  v-show="visEval(navSection.visible)" >
            <!--SECTION HEADING-->
            <h5 v-if="navSection.sectionLabel && visEval(navSection.visible)" 
            class="sidebar-header">{{navSection.sectionLabel}}</h5>

            <nav-bar-item :items="navSection.subs" :class="navSection.styleClasses" >
                <template slot="item" slot-scope="props"> </template>
            </nav-bar-item>
        </nav>

</template>

<script>
    import navBarItem from './navbaritem.vue';
    export default {
        name: 'nav-bar',
        props: ['navSection'],
        mounted() {
        },

        methods: {
            // handles null, value or func TODO make global
            visEval: function(func) {
                return typeof func === "function" ? func() : (func != null ? func : 1 )
            }
        },

        data() {
            return {}
        },
        components: {
            navBarItem
        }
    }
</script>

<style>

</style>
